/** Shared responsive layout tokens for admin pages. */
export const adminPageSx = {
  m: { xs: 1, sm: 1.5, md: "20px" },
  pb: { xs: 2, md: 3 },
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
};

export const adminScrollPageSx = {
  ...adminPageSx,
  height: { xs: "auto", md: "80vh" },
  minHeight: { xs: "calc(100vh - 120px)", md: "auto" },
  overflow: "auto",
  pr: { xs: 0.5, md: "20px" },
};

export const adminDataGridBoxSx = {
  width: "100%",
  height: { xs: "62vh", sm: "58vh", md: "55vh" },
  minHeight: { xs: 320, sm: 380, md: 420 },
  overflow: "hidden",
};

export const adminPageHeaderSx = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", sm: "center" },
  gap: 2,
};
